// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__wy7Fl","logoContainer":"Sidebar_logoContainer__ZR+xV"};